import { render, staticRenderFns } from "./ProductImage.vue?vue&type=template&id=62b6b16d&scoped=true&"
import script from "./ProductImage.vue?vue&type=script&lang=js&"
export * from "./ProductImage.vue?vue&type=script&lang=js&"
import style0 from "./ProductImage.vue?vue&type=style&index=0&id=62b6b16d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b6b16d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62b6b16d')) {
      api.createRecord('62b6b16d', component.options)
    } else {
      api.reload('62b6b16d', component.options)
    }
    module.hot.accept("./ProductImage.vue?vue&type=template&id=62b6b16d&scoped=true&", function () {
      api.rerender('62b6b16d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/themes/default/components/core/ProductImage.vue"
export default component.exports